import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { GetClasses } from '@lifeomic/chroma-react/typeUtils';
import { Pill } from '@lifeomic/chroma-react/components/Pill';
import { Fade } from '@mui/material';

const messages = defineMessages({
  selectedVariants: {
    id: 'SelectedCountPillOE.selectedVariants',
    defaultMessage: '{selectedCount} Selected',
  },
});

export const useStyles = makeStyles((_theme: Theme) => ({
  root: {},
}));

export type SelectCountPillOEClasses = GetClasses<typeof useStyles>;

export interface SelectCountPillOEOwnProps {
  selectedCount?: number;
}

export type SelectCountPillOEProps = SelectCountPillOEOwnProps;

const SelectCountPillOE: React.FC<SelectCountPillOEOwnProps> = ({
  selectedCount,
}) => {
  const formatMessage = useIntl().formatMessage;

  const pillMessage = formatMessage(messages.selectedVariants, {
    selectedCount,
  });

  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  if (selectedCount < 1) return null; // prevents visual flicker when count === 0

  return (
    <Fade in={!!selectedCount} timeout={{ enter: 600, exit: 100 }}>
      <div>
        <Pill label={pillMessage} color="primary" />
      </div>
    </Fade>
  );
};

export default React.memo(SelectCountPillOE);
